import { createRouter, createWebHashHistory } from 'vue-router';

// 路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/customercase/index',
    name: 'Customercase',
    component: () => import('@/views/Solution/customercase/index.vue')
  },
  {
    path: '/smartCampus/index',
    name: 'smartCampus',
    component: () => import('@/views/Solution/smartCampus/index.vue')
  },
  {
    path: '/Smartsocialworker/index',
    name: 'Smartsocialworker',
    component: () => import('@/views/Solution/Smartsocialworker/index.vue')
  },
  {
    path: '/YiLinwz/index',
    name: 'YiLinwz',
    component: () => import('@/views/Solution/YiLinwz/index.vue')
  },
  {
    path: '/CloudCare/index',
    name: 'CloudCare',
    component: () => import('@/views/ProductCenter/CloudCare/index.vue')
  },
  {
    path: '/NetCare/index',
    name: 'NetCare',
    component: () => import('@/views/ProductCenter/NetCare/index.vue')
  },
  {
    path: '/LightweightCloud/index',
    name: 'LightweightCloud',
    component: () => import('@/views/ProductCenter/LightweightCloud/index.vue')
  },
  {
    path: '/Container/index',
    name: 'Container',
    component: () => import('@/views/ProductCenter/Container/index.vue')
  },
  {
    path: '/TrainingPlatform/index',
    name: 'TrainingPlatform',
    component: () => import('@/views/ProductCenter/TrainingPlatform/index.vue')
  },
  {
    path: '/GpuVirtualization/index',
    name: 'GpuVirtualization',
    component: () => import('@/views/ProductCenter/GpuVirtualization/index.vue')
  },
  {
    path: '/CloudMigration/index',
    name: 'CloudMigration',
    component: () => import('@/views/ProductCenter/CloudMigration/index.vue')
  },
  {
    path: '/MulticloudManagement/index',
    name: 'MulticloudManagement',
    component: () => import('@/views/ProductCenter/MulticloudManagement/index.vue')
  },
  {
    path: '/MultiPowerManagement/index',
    name: 'MultiPowerManagement',
    component: () => import('@/views/ProductCenter/MultiPowerManagement/index.vue')
  },
  {
    path: '/LargemodelService/index',
    name: 'LargemodelService',
    component: () => import('@/views/ProductCenter/LargemodelService/index.vue')
  },
  {
    path: '/productPrice/index',
    name: 'productPrice',
    component: () => import('@/views/ProductCenter/productPrice/index.vue')
  },
  {
    path: '/StandardTraining/index',
    name: 'StandardTraining',
    component: () => import('@/views/ProductCenter/StandardTraining/index.vue')
  }
];

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  }
});

// 路由守卫：确保每次路由变化时滚动到顶部
router.beforeEach((to, from, next) => {
  // 滚动到顶部
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  next();
});

export default router;